import React from 'react'
import { Alert } from 'react-bootstrap'
import styled from 'styled-components'

const StyledAlert = styled(Alert)`
  margin: 1.5rem 0;
  text-align: center;
  font-weight: 500;
`

const NoDataAlert = ({ text }) => {
  return <StyledAlert variant='info'>{text}</StyledAlert>
}

export default NoDataAlert
